import { AxiosResponse} from "axios";
import Api from "../api";

export default (listingId : number): Promise<AxiosResponse> => {
    const path = 'posts'
    return Api.getInstance().request.get(`${path}/${listingId}?fields=local_phone,phone`, path)
}